import BaseCommand from "@/models/api/commands/BaseCommand";
import { CALCULATE_ORDER_ITEM_VALUE } from "@/static/calculateOrderItemValueTypes";

export interface CalculateFromValueParam {
  CalculateType: CALCULATE_ORDER_ITEM_VALUE;
  Value: number;
  BookingItemTmpId: string;
}

export class CalculateFromValueCommand extends BaseCommand {
  CommandName = "CalculateFromValue";
  Command: CalculateFromValueParam;
  constructor(sessionId: string, operationId: string, param: CalculateFromValueParam) {
    super(sessionId, operationId);
    this.Command = param;
  }
}
